import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthApi } from '../../Api/BaseApi'; // AuthApi.isAuthenticated now includes chatUserId check

const PublicRoute = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authStatus = await AuthApi.isAuthenticated();
        setIsAuthenticated(authStatus);
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setIsChecking(false);
      }
    };
    
    checkAuth();
  }, []);

  // Show nothing while checking authentication
  if (isChecking) {
    return null;
  }

  // If isAuthenticated is true (meaning FastApi token exists AND chatUserId exists)
  if (isAuthenticated) {
    // User is fully authenticated (both FastApi and Chat backend identified),
    // so redirect them from public pages (like login/register) to the main app (e.g., home page).
    return <Navigate to="/" replace />;
  }

  // If not authenticated, render the children (e.g., LoginPage, RegisterPage)
  return children;
};

export default PublicRoute;